import request from './request'

export function getHospital(id) {
    return request.get('/api/hosp/info', {
        params: {
            id: id
        }
    })
}

export function getUnion(unionCode) {
    return request.get('/api/Hosp/unions', {
        params: {
            code: unionCode
        }
    })
}

export function getConfigs(hospId) {
    return request.get('/api/Hosp/configs', {
        params: {
            hospId
        }
    })
}

export function getEnvironment() {
    return request.get('/api/Hosp/env')
}

export function getHomePageModules(hospId) {
    return request.get('/api/Hosp/homePageModules', {
        params: {
            hospId
        }
    })
}